export default "__VITE_ASSET__Dt2ChWXQ__"